import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Banner } from '../../components/Banner';
import { AuthShell } from './AuthShell';
import { authErrorMessage, resolveTotpSignIn, setPendingResolver, takePendingResolver, totpHint as findTotpHint, NO_TOTP_FACTOR } from './mfa';

export function TotpVerifyPage() {
  const navigate = useNavigate();
  const resolver = takePendingResolver();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!resolver) return <Navigate to="/login" replace />;

  const totpHint = findTotpHint(resolver);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!resolver || !totpHint) return;
    setError(null);
    setLoading(true);
    try {
      await resolveTotpSignIn(resolver, totpHint, code);
      setPendingResolver(null);
      navigate('/', { replace: true });
    } catch (err) {
      setError(authErrorMessage((err as { code?: string }).code));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell title="Código de verificación" subtitle="Ingresa el código de 6 dígitos de tu app de autenticación.">
      {!totpHint ? (
        <Banner tone="error">{NO_TOTP_FACTOR}</Banner>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          {error && <Banner tone="error">{error}</Banner>}
          <Input
            label="Código"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={7}
            mono
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="text-center text-xl"
          />
          <Button type="submit" block size="lg" loading={loading} disabled={code.replace(/\s/g, '').length !== 6}>
            Verificar
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
